module.exports = __webpack_public_path__ + "img/index13.eb8f14f9.png";